import Device from 'constants/deviceSizes';
import { appConfig } from 'config/customization';

export default {
  fullContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    width: '100%'
  },
  container: {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    height: 'calc(100% - 35px - 35px',
    justifyContent: 'center',
    padding: '20px 30px',
    width: '100%',
    [Device.mobile]: {
      height: 'calc(100% - 35px)'
    }
  },
  icon: {
    color: appConfig.colors.lightGray,
    fontSize: 45,
    marginRight: 5
  }
};
